import { useEffect, useState } from 'react';

function prefersReduced(): boolean {
  return typeof window !== 'undefined' && !!window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
}

/**
 * Count up from 0 to `end` on mount (cubic ease-out, ~900ms) for the analytics
 * dashboards. Honours prefers-reduced-motion by rendering the final value immediately.
 */
export function Count({
  end,
  suffix = '',
  prefix = '',
  ms = 900,
  decimals = 0,
}: {
  end: number;
  suffix?: string;
  prefix?: string;
  ms?: number;
  decimals?: number;
}) {
  const [v, setV] = useState(prefersReduced() ? end : 0);

  useEffect(() => {
    if (prefersReduced()) {
      setV(end);
      return;
    }
    let raf = 0;
    let start = 0;
    const tick = (ts: number) => {
      if (!start) start = ts;
      const t = Math.min(1, (ts - start) / ms);
      const eased = 1 - Math.pow(1 - t, 3);
      setV(end * eased);
      if (t < 1) raf = requestAnimationFrame(tick);
      else setV(end);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [end, ms]);

  return (
    <>
      {prefix}
      {decimals > 0 ? v.toFixed(decimals) : Math.round(v)}
      {suffix}
    </>
  );
}
